import { FileText } from 'lucide-react';
import { Button } from '../button';

// MaterialIcon.js
export function InfoButton({
  onClick,
  className = '',
  size = 16,
  children,
  ...props
}) {
  return (
    <Button
      variant="squareOutline"
      size="sm"
      onClick={onClick}
      className={className}
      {...props}
    >
      <FileText className="h-2 w-2" />
      <span className="text-xs/6">{children || 'Informacija'}</span>
    </Button>
  );
}
